import { createApp } from 'vue'
import App from './App.vue'
const app = createApp(App);
import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import "bootstrap/dist/css/bootstrap.min.css"
import "@/assets/Agent/css/style.css";
import "@/assets/Agent/css/responsive.css";
import $ from 'jquery';
window.jQuery = $;
import moment from "moment";
import "bootstrap/dist/js/bootstrap.js"
import 'vue3-carousel/dist/carousel.css'
import momentPlugin from './plugins/moment';
const pinia = createPinia();
pinia.use(createPersistedState());
app.config.globalProperties.$moment = moment;
import router from './routes.js'
app.use(momentPlugin);
app.use(pinia);
app.use(router);
app.directive('lazy', {
    beforeMount(el, binding) {
        el.src = binding.value;
    }
});
document.title = 'Agent - Login';
app.mount('#app');


